<template>
  <!--  testovaci karta 5447380000000006 -->
  <div class="container sidelighted">

    <div class="d-flex blue" style="justify-content: center">
      <img :src="logo_url()" class="cart_logo"/>
    </div>

    <div class="item blue" v-if="step==2 || true">
      <div style="padding-left: 10px">
        <h3>  {{ $t('cart.your_order')}} </h3>
      </div>
      <product-table-kk :items="items" :cart="cart" @changeProduct="changeProduct" v-if="cart.table_template == 'kk'"></product-table-kk>
      <product-table-ll :items="items" :cart="cart" :previous-ll-lesson="previous_ll_lesson" @changeProduct="changeProduct" v-if="cart.table_template == 'll'"></product-table-ll>
      <product-table-default :items="items" :cart="cart" @changeProduct="changeProduct" v-else></product-table-default>
    </div>

    <div class="blue">
      <div class="title-data">
        <h3>{{ $t('cart.your-details') }}</h3>
      </div>

      <div class="col-md-11" style="padding-left: 48px;">
        <hr>
      </div>

      <div class="item">
        <billing-fields v-if="step==1 || true" :student="student" @billing="handleBillingChange"></billing-fields>
        <div class="shoping-cart-step-2" style="padding-bottom: 50px; padding-left: 10px;" v-if="step==2 || true">
          <div class="wcf-coupon-col-12" style="margin-bottom: 15px">
            <label for="billing_email" class="">{{$t('cart.discount-code')}}<abbr class="required" title="vyžadováno"> </abbr></label>

            <input
                type="text"
                v-model="discount_code"
                class="input-code"
                placeholder="Kód kupónu"
                id="coupon_code"
                value=""
            />

            <button :disabled="!codeIsFilled" type="button" class="code-button" @click.prevent="applyCouponCode">
              {{ $t('cart.apply') }}
            </button>
          </div>

<!--          <div class="col-md-12">-->
<!--            <hr>-->
<!--          </div>-->

          <div class="d-flex" style="margin-bottom:40px;">
            <div style="width: 20px">
              <input type="checkbox" class="checkbox_input" id="conditions-checkbox" v-model="checked"/>
            </div>
            <div>
              <label for="conditions-checkbox"> {{$t('cart.i-have-read')}}</label>
            </div>
            <div>
              <a href="https://www.onlinejazyky.cz/smluvni-podminky.html" target=”_blank”>{{$t('cart.terms-and-conditions')}}</a><br>
            </div>
          </div>

          <div class="row">
            <div>
              <button :disabled="!fieldsAreFilled||!checked||!emailValid" @click.prevent="handle_create_order">
                {{ $t('cart.checkout') }}
              </button>
            </div>
          </div>

        </div><!-- shoping-cart-step-2 -->
      </div><!-- item -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SetPassword from "./set-password.vue";
import CbGr from "./cb-gr.vue";
import ProductTableKk from "./product-table-kk.vue";
import ProductTableDefault from "./product-table-default.vue";
import ProductTableLl from "./product-table-ll.vue";
import BillingFields from "./billing-fields.vue";
import {toast} from "vue3-toastify";
export default {
  props: ["objid"],
  components: { BillingFields, ProductTableDefault, ProductTableKk, SetPassword, CbGr, ProductTableLl},
  name: "shopping-cart",
  data() {
    return {
      step: 1,
      company_box: false,
      items: [],
      billing: {
        email: "",
        first_name: "",
        last_name: "",
        ic: "",
        dic: "",
        dic_dph: "",
        company: "",
        tel:'',
      },

      discount_code: "",
      payment_id: null,
      currency: 'CZK',

      order_id: null,
      cart: {},
      student:{},
      previous_ll_lesson: null,
      iframe_gopay_url: null,
      paymentSessionId: null,
      encryptedSignature: null,
      checked: false,
    };
  },
  computed: {
    fieldsAreFilled() {
      return this.billing.email && this.billing.first_name && this.billing.last_name && this.billing.tel
    },
    codeIsFilled() {
      return this.discount_code
    },
    emailValid(){
      return this.isValidEmail(this.billing.email)
    }
  },

  mounted() {
    window.dataLayer = window.dataLayer || [];
    this.loadCart(this.ga_begin_checkout);
  },
  methods: {



    ga_begin_checkout(){

      console.log("GA begin checkout", this.cart.get_discounted_price );
      window.dataLayer.push({
        event: 'begin_checkout',
        ecommerce: {
          currency: this.cart.currency_code,
          value: this.cart.get_discounted_price,  // Celková hodnota košíku
          items: this.items.map(item => ({
            item_id: item.product.id,
            item_name: item.product.name,
            price: item.price_with_tax,
            quantity: item.qty
          }))
        }
      });
    },

    ga_add_payment_info(){
      console.log("GA add payment info", this.cart.get_discounted_price );
      window.dataLayer.push({
        event: 'add_payment_info',
        ecommerce: {
          currency: this.cart.currency_code,
          payment_type: 'GoPay',
          value: this.cart.get_discounted_price,  // Celková hodnota košíku
          items: this.items.map(item => ({
            item_id: item.product.id,
            item_name: item.product.name,
            price: item.price_with_tax,
            quantity: item.qty
          }))
        }
      });
    },


    isValidEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email.toLowerCase());
    },

    logo_url() {
      const onla = `/img/OJ_onlajnovka_logo_tmave_bez_url@2x.png`

      const oj = `/img/OJ_Logo.svg`

      console.log('this.cart.brand', this.cart.brand)

      if (this.cart.brand=='onla') return onla

      if (this.cart.brand=='el') return `/img/logo-el.svg`

      if (this.cart.brand=='oj') return oj
      return ''
    },

    handleProductAdded() {

      this.loadCart()
    },

    handleBillingChange(billing) {
      this.billing = billing;
    },


    handleStep1Submitted(billing){
      this.billing = billing;
      this.step = 2;
    },

    changeProduct(it) {
      console.log('change product', it, it.selected_variant)
      axios.put(`/shopping_cart/change_product/${it.id}`, {
        product_id: it.selected_variant,
        qty: it.qty,
        objid: this.objid,
        lector_id: it.lector_id,
        lesson_minutes: it.lesson_minutes,
      }).then((response) => {
        this.loadCart()
      })
    },

    loadCart(callBack) {
      axios.get(`/shopping_cart/cart`, {params: {objid: this.objid}}).then((response) => {
        this.items = response.data.items;
        this.cart = response.data.cart;
        this.student = response.data.student;
        this.previous_ll_lesson = response.data.previous_ll_lesson;

        if (this.step === 1){
          this.student = response.data.student;
        }

        if (callBack && typeof callBack === "function") {
          callBack()
        }

      });
    },

    applyCouponCode() {
      const data = {
        code: this.discount_code,
        objid: this.objid,
        currency: this.currency
      }
      axios.post('/shopping_cart/discount-code', data).then((response) => {
        if (response.data.code && response.data.code.id > 0) {
          this.loadCart()
          //this.$toasted.success("Kupón byl úspěšně použit", {duration: 5000});
          toast( this.$t("cart.discount-code-ok"), {type: 'success'});
        } else {
          //this.$toasted.error("Neplatný kupón", {duration: 5000});
          toast(  this.$t('cart.invalid-discount-code'), {type: 'error'});
        }
      }).catch((error) => {
        //console.log(error);
        //this.$toasted.error("Neplatný kupón", {duration: 5000});
        toast('Neplatný kupón: '+ error.response.data.error, {type: 'error'});
      });
    },

    handle_create_order() {
      const data = {
        billing: this.billing,
        discount_code: this.discount_code,
        objid: this.objid,
      };
      axios.post(`/shopping_cart/create-order`, data).then((response) => {
        this.payment_id = response.data.payment.id;
        this.paymentSessionId = response.data.gopay_payment_session_id;
        this.encryptedSignature = response.data.encrypted_signature;
        const url = response.data.gopay_url
        if (url) {

          this.ga_add_payment_info()


          //window.location.href = url;
          this.iframe_gopay_url = url
          window._gopay.checkout({gatewayUrl: url, inline: true});
        }
      }).catch((error) => {
        console.log(error);
        //this.$toasted.error("Chyba při vytváření objednávky - " + error.response.data.error, {duration: 5000});
                toast('Chyba při vytváření objednávky - ' + error.response.data.error, {type: 'error'});
      });
    },
  },
};
</script>

<style scoped lang="scss">

@media only screen and (max-width: 768px) {
  label {
    text-align: right;
  }
}

label {
  width: 100px;
  text-align: right;
  display: inline-flex;
}

.container {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: center;
}

.item {
  flex-grow: 1;
  padding: 10px 10px 0px 10px;
  padding: 50px;
}

.title-data {
  padding-left: 48px;
  padding-top: 40px;
}

.itemFU1 {
  flex-grow: 1;
  padding: 10px 10px 10px 13px;
}

.itemFU2 {
  flex-grow: 1;
  padding: 10px 10px 10px 0px;
}

input {
  background-color: white;
  width: 200px;




padding: 11px 12px;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #d4d4d4;
  border-radius: 3px;

}

input:focus {
  //outline: none !important;
  border-color: #37A8D6;
  border-style: solid;
  box-shadow: 0 0 2px #37A8D6;

}

.input-code {
  width: 120px;
}

.code-button {
  background-color: #37A8D6;
  border-radius: 20px;
  border: none;
  padding: 5px 20px 5px 20px;
  height: 28px;
  width: 80px;
  color: white;
  text-align: center;
  font-family: 'Proxima Nova', sans-serif;
  font-size: 0.8rem;
  //font-weight: bold;
  //text-transform: uppercase;
  margin-left: 10px;
  padding: 0px 9px 0px 9px;
}

button {
  background-color: #37A8D6;
  color: white;
  font-size: 1rem;
  border-radius: 20px;
  border: none;
  padding: 5px 20px 5px 20px;
  margin-left: 5px;
  //text-transform: uppercase;
  font-weight: bold;
}

button:disabled,
button[disabled] {
  background-color: lightgrey;
  color: white;
}

select {
  padding: 3px 7px 3px 7px;
}

input[type="checkbox"] {
  width: 10px;
  margin-left: 4px;
}

.shad {
  box-shadow: 0 2px 10px 8px lightgrey;
}

.blue {
  //background-color: #d8f9ff;
  //background-color: #e2f3fb
}

.sidelighted{

  background: url('/img/bg-side-light2.svg') repeat-y;
  background-color: #e2f3fb;
  background-size: contain;
  background-position: left center;
  padding-left:40px;
}


.cart_logo{
  width: 200px;
  height: auto;
  margin-top: 20px;
  margin-bottom: 20px;
}

  @media only screen and (max-width: 768px) {
    .cart_logo {
      width: 150px;
    }

    .item{
      padding: 20px 40px;
    }
    .title-data{
      padding-top:0;
    }
  }

</style>
